// mimic the enum-like behaviour

// export const AlertType = {
//   0: 'none',
//   10: 'manager',
//   20: 'admin',
// }
export const AppColumnType = {
  10: 'text_short',
  20: 'text',
  30: 'phonenumber',
  40: 'coordinates_latitude',
  41: 'coordinates_longitude',
  42: 'coordinates_gps',
  50: 'datetime',
  60: 'email',
  70: 'number',
  80: 'url',
  90: 'country',
  100: 'mcq',
  110: 'select',
  120: 'address',
  130: 'data_video',
  140: 'data_audio',
  150: 'data_image',
  160: 'data_url',
  170: 'data_text',
  175: 'data_numeric',
  180: 'data_embed',
  185: 'data_iframe',
  190: 'block',
  200: 'multiselect',
  201: 'multiselect_item',
  210: 'multimcq',
  211: 'multimcq_tem',
  220: 'file',
  230: 'input_json',
  240: 'api_select',
  250: 'api_multiselect',
  260: 'rib',
};
export const CertificationState = {
  1: 'draft',
  10: 'online',
  20: 'offline',
  100: 'archived',
};
// export const DocumentState = {
//   10: 'creation',
//   20: 'ocr',
//   30: 'done',
//   100: 'error',
// }
export const FormState = {
  10: 'creating',
  20: 'published',
  99: 'archived',
};
export const ProjectState = {
  1: 'extractionParameter',
  2: 'settings',
  3: 'audienceDefinition',
  4: 'addData',
  10: 'online',
  15: 'boosted',
  20: 'done',
  30: 'archived',
  40: 'stop',
  50: 'paused',
};
// export const CrowdType = {
//   10: 'internal',
//   11: 'candidates',
//   20: 'external',
// }
// export const Frequency = {
//   10: 'few',
//   20: 'often',
// }
export const ModelCategory = {
  10: 'owned',
  100: 'wirk',
};
export const ModelState = {
  10: 'create',
  20: 'train',
  30: 'online',
  100: 'error',
  999: 'archived',
};
export const Quality = {
  10: 'simple',
  20: 'multi',
  30: 'panel',
  40: 'relecture',
};
export const QuestionState = {
  1: 'draft',
  10: 'published',
  20: 'deleted',
};
export const ResourceType = {
  1: 'string',
  10: 'number',
};
// export const SegmentType = {
//   10: 'manual',
//   20: 'auto',
//   30: 'certification',
//   40: 'sociodemographic',
// }
export const SkillType = {
  0: 'simpleDataEntry',
  1: 'complexDataEntry',
  2: 'simpleDocumentAnalysis',
  3: 'complexDocumentAnalysis',
  4: 'folderAnalysis',
  5: 'contentRedaction',
  6: 'webSearch',
  7: 'bounding',
  8: 'transcription',
  9: 'outgoingCall',
  10: 'incomingCall',
  11: 'officeAutomation',
};
export const SociodemographicCriteria = {
  0: 'age',
  1: 'country',
  2: 'department',
  3: 'region',
  4: 'nationality',
  5: 'gender',
  6: 'seniority',
  7: 'activity',
  8: 'profession',
  9: 'children',
  10: 'maritalStatus',
  11: 'earnings',
  12: 'education',
};
export const UserAccessLevel = {
  0: 'noAccess',
  10: 'creator',
  20: 'user',
  30: 'admin',
};
// export const UserActivityState = {
//   0: 'online',
//   1: 'offline',
//   2: 'waitingActivation',
//   3: 'archived',
// }
export const UserCertificationState = {
  0: 'new',
  10: 'inProgress',
  20: 'done',
  30: 'reviewed',
};
export const UserType = {
  0: 'superAdmin',
  10: 'admin',
  20: 'manager',
  30: 'worker',
  40: 'candidate',
};
// export const WorkflowType = {
//   10: 'active',
//   20: 'manual',
// }
// export const UserStatus = {
//   0: 'active',
//   1: 'inactive',
//   2: 'waiting',
// }

// export const TaskOriginType = {
//   1: 'Web',
//   2: 'Api',
//   3: 'Auto',
// }

// export const TaskStateType = {
//   10: 'inCreation',
//   20: 'onHold',
//   30: 'inProgress',
//   80: 'urgent',
//   90: 'late',
//   100: 'completed',
//   900: 'cancelled',
//   999: 'error',
// }
// export const Event = {
//   //TASK EVENTS
//   100: 'TaskCreation',
//   101: 'ModelExtraction',
//   102: 'CreationInitialHit',
//   103: 'HitComparison',
//   104: 'CreationAdditionnalHit',
//   105: 'CreationReviewHit',
//   106: 'CreationOverrideHit',
//   107: 'TaskDone',
//
//   // HIT EVENTS
//   200: 'HitCreation',
//   201: 'WorkingHit',
//   202: 'ManualReleaseHit',
//   203: 'AutoReleaseHit',
//   204: 'HitAttributionAuto',
//   205: 'HitAttributionManual',
//   206: 'HitReview',
//   207: 'DoneHit',
//
//   // DOCUMENT EVENTS
//   300: 'DocumentCreation',
//   301: 'DocumentModelEvalutation',
//   302: 'DocumentExtraction',
//   303: 'DocumentExtractionResult',
// }

export const HitType = {
  1: 'initial',
  2: 'iteration',
  3: 'arbitrage',
  4: 'review',
  5: 'override',
};

export const HitStateType = {
  1: 'inCreation',
  2: 'onHold',
  3: 'inProgress',
  4: 'completed',
  5: 'validated',
  6: 'refused',
  100: 'cancelled',
};

// export const AudienceCombinationType = {
//   10: 'and',
//   20: 'or',
// }

// export const Resources = {
//   nationality: 4,
// }

// export type TAlertType = keyof typeof AlertType
export type TAppColumnType = keyof typeof AppColumnType;
export type TAppColumnValues = (typeof AppColumnType)[TAppColumnType];
export type TCertificationState = keyof typeof CertificationState;
// export type TDocumentState = keyof typeof DocumentState
export type TFormState = keyof typeof FormState;
export type TProjectState = keyof typeof ProjectState;
// export type TCrowdType = keyof typeof CrowdType
// export type TFrequency = keyof typeof Frequency
export type TModelCategory = keyof typeof ModelCategory;
export type TModelState = keyof typeof ModelState;
export type TQuality = keyof typeof Quality;
// export type TQualityValues = (typeof Quality)[TQuality]
export type TQuestionState = keyof typeof QuestionState;
export type TResourceType = keyof typeof ResourceType;
// export type TSegmentType = keyof typeof SegmentType
export type TSkillType = keyof typeof SkillType;
export type TSociodemographicCriteria = keyof typeof SociodemographicCriteria;
export type TSociodemographicCriteriaValues =
  | 'age'
  | 'country'
  | 'department'
  | 'region'
  | 'nationality'
  | 'gender'
  | 'seniority'
  | 'activity'
  | 'profession'
  | 'children'
  | 'maritalStatus'
  | 'earnings'
  | 'education';
export type TUserAccessLevel = keyof typeof UserAccessLevel;
export type TUserCertificationState = keyof typeof UserCertificationState;
export type TUserType = keyof typeof UserType;
// export type TWorkflowType = keyof typeof WorkflowType
// export type TTaskOrigin = keyof typeof TaskOriginType
// export type TTaskState = keyof typeof TaskStateType
// export type TEvent = keyof typeof Event
export type THitState = keyof typeof HitStateType;
export type THitType = keyof typeof HitType;
// export type TAudienceCombinationType = keyof typeof AudienceCombinationType
